import type { ReactNode } from 'react'

export interface AuthCardProps {
  title: ReactNode
  description?: ReactNode
  children: ReactNode
  footer?: ReactNode
}

/** Carte centrée des écrans d'authentification (connexion, inscription, code…). */
export function AuthCard({ title, description, children, footer }: AuthCardProps) {
  return (
    <div className="auth-wrap">
      <div className="card auth-card">
        <div className="auth-head">
          <h1 className="font-display">{title}</h1>
          {description && <p className="text-muted">{description}</p>}
        </div>
        <div className="auth-body">{children}</div>
      </div>
      {footer && <div className="auth-foot">{footer}</div>}
    </div>
  )
}
